import React from 'react';
import projectsData from '../data/projects.json';
import Section from './Section';

const Projects = () => {
  return (
    <Section id="projects" label="Projects">
      <ul className="space-y-12">
        {projectsData.map((project) => {
          const { title, period, description, tech, url, github } = project;
          const siteUrl = typeof url === 'string' ? url.trim() : '';
          const repoUrl = typeof github === 'string' ? github.trim() : '';
          const primaryHref = siteUrl || repoUrl;

          return (
            <li key={title}>
              <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
                <h3 className="font-display text-xl font-semibold tracking-tight text-ink">
                  {primaryHref ? (
                    <a
                      href={primaryHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-accent"
                    >
                      {title}
                    </a>
                  ) : (
                    title
                  )}
                </h3>
                <p className="shrink-0 text-sm tabular-nums text-muted">{period}</p>
              </div>
              {siteUrl && repoUrl ? (
                <a
                  href={repoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-accent mt-1 inline-block text-sm text-muted hover:text-ink"
                >
                  GitHub
                </a>
              ) : null}
              <p className="mt-3 max-w-prose leading-relaxed text-ink/80">{description}</p>
              <p className="mt-3 text-sm text-muted">
                {tech.join(' · ')}
              </p>
            </li>
          );
        })}
      </ul>
    </Section>
  );
};

export default Projects;
